import React, { useState } from 'react';
import { useFetch } from '../../common/utils/hooks';

const Recruitment = (props) => {
  const { panelText, stateValueListUrl, emptyResultText, defaultOptionText } = props.content;
  const endpointUrl = `/halapi/documents?_scope=${stateValueListUrl}`;
  const [isEmpty, setIsEmpty] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const { status, data, error } = useFetch(endpointUrl);
  const stateList = data?._embedded?.documents[0].listitem;

  function filterOptions(event) {
    const selection = event.currentTarget.value;

    let table = document.querySelector('.option-advisor-table');
    let rows = document.getElementsByTagName('tr');
    let isEmptyNew = true;
    for (const row of rows) {
      const td = row.getElementsByTagName('span')[0];
      if (!td) {
        continue;
      }
      const matches = td.textContent?.split(', ').filter(function (state) {
        return state.trim() == selection;
      });
      if (matches?.length) {
        isEmptyNew = false;
        row.style.display = 'flex';
      } else {
        row.style.display = 'none';
      }
    }
    setIsEmpty(isEmptyNew);
    setSelectedValue(selection);
    if (isEmptyNew) {
      table.style.display = 'none';
    } else {
      table.style.display = 'block';
    }
  }
  switch (status) {
    case 'idle': {
      return <div />;
    }
    case 'error': {
      return <div>{error}</div>;
    }
    case 'fetching': {
      return (
        <div className="Loading u-textColorBrandLight">
          <div className="Loading-indicator"></div>
          <div className="Loading-indicator"></div>
          <div className="Loading-indicator"></div>
        </div>
      );
    }

    default: {
      return (
        <div className="Dropdown-group">
          <div className="Dropdown u-size1of3 u-sm-sizeFull">
            <select
              id="mySelect"
              className="Dropdown-menu"
              onChange={filterOptions}
              data-analytics="ear-next-step-state-dropdown">
              <option className="Content" disabled selected value="">
                {defaultOptionText}
              </option>
              {stateList?.map((state) => {
                return (
                  <option
                    className="select-option Content"
                    key={state.key}
                    value={state.label}
                    data-analytics="state-option">
                    {state.label}
                  </option>
                );
              })}
            </select>
          </div>

          {isEmpty && <div className="Content u-paddingVert6gu">{emptyResultText}</div>}
          {selectedValue && !isEmpty && <div className="Content u-paddingVert6gu">{panelText}</div>}
        </div>
      );
    }
  }
};

export default Recruitment;
